<ng-container *ngIf="select$ | async"></ng-container>

<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span class="title dialog-title" i18n>Облицовка на замену</span>

      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <table mat-table #table [dataSource]="dataSource" class="w-full matched-edges-table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef i18n>Название</th>
        <td mat-cell *matCellDef="let item">
          {{ item.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="article">
        <th mat-header-cell *matHeaderCellDef i18n>Артикул</th>
        <td mat-cell *matCellDef="let item">
          {{ item.article }}
        </td>
      </ng-container>

      <ng-container matColumnDef="thickness">
        <th mat-header-cell *matHeaderCellDef i18n>Толщина</th>
        <td mat-cell *matCellDef="let item">
          {{ item.thickness }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr
        mat-row
        (click)="selection.select(row)"
        [ngClass]="{ selected: selection.isSelected(row) }"
        class="matched-edge-row"
        *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </div>

  <mat-divider> </mat-divider>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row-reverse justify-between items-center">
    <div>
      <button mat-raised-button class="mat-accent" (click)="dialogRef.close(selection.selected)" i18n>ОК</button>
      <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
    </div>

    <button
      *ngIf="cuttingOptions && cuttingOptions.cuttingProductSettings.addMaterialsFromMatBase"
      i18n-matTooltip
      matTooltip="Выбрать облицовку из базы материалов"
      mat-icon-button
      (click)="openMaterialBaseDialog()">
      <mat-icon>layers</mat-icon>
    </button>
  </div>
</div>
